import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22ebwf84sbiga">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1ydrulr99nqnt">
        <div className="text-center" data-id="element-22" data-mp="1ybx9abu31wj7">
          <span className="inline-flex items-center gap-2 rounded-md bg-gold px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-field-deep" data-id="element-23" data-mp="1anxmfmzw6q9w">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="15n9m2aprwx30" /> Bonos incluidos
          </span>
          <h2 id="bonus-title" className="mt-4 text-3xl font-extrabold text-field sm:text-4xl" data-id="element-25" data-mp="1jivi31ufch4x">Los {totalBonuses} bonos estratégicos</h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="qzojchwt8zvm">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex flex-col rounded-xl border bg-white p-6 shadow-card ${bonus.wide ? 'border-2 border-gold md:col-span-2' : 'border-line'}`} data-id="element-27" data-mp="mymixxr5qhs2" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-28" data-mp="1qv1stgfyv10w">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-field text-gold" data-id="element-29" data-mp="1vrik2jigpvi7">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-30" data-mp="20qd94370wgar" />
                  </span>
                  <p className="text-[11px] font-extrabold uppercase tracking-[.16em] text-earth" data-id="element-31" data-mp="25qribokd1wad">Bono {bonus.number}</p>
                </div>
                <h3 className="mt-4 text-lg font-extrabold leading-tight text-field" data-id="element-32" data-mp="3c8o5z0un46wy">{bonus.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-33" data-mp="3h7rb0lamed4x">{bonus.description}</p>

                {bonus.items && <ul className="mt-4 flex flex-wrap gap-2" data-id="element-34" data-mp="1h586cwrp3f9y">
                    {bonus.items.map(item => <li key={item} className="rounded-md border border-line bg-cream px-3 py-1 text-xs font-semibold text-earth-dark" data-id="element-35" data-mp="1c6etn6k8fsau">
                        {item}
                      </li>)}
                  </ul>}

                {bonus.purpose && <p className="mt-4 flex-1 rounded-lg border-l-4 border-field bg-field-tint px-4 py-3 text-sm text-ink" data-id="element-36" data-mp="yce3h17cjdm3">
                    Ideal para <b className="font-extrabold" data-id="element-37" data-mp="tf43irmbzjk0">{bonus.purpose}</b>.
                  </p>}

                <p className="mt-auto flex flex-wrap items-center justify-between gap-3 border-t border-line pt-4 text-sm" data-id="element-38" data-mp="1769724stkvzm">
                  <span className="text-muted line-through" data-id="element-39" data-mp="12d7tc04cn2hm">Valor {bonus.value}</span>
                  <span className="rounded-md bg-field px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-gold" data-id="element-40" data-mp="endfpgc7h9wb">Gratis</span>
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl border-b-4 border-earth bg-field px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-41" data-mp="i3dhy0xmm1q">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-gold" data-id="element-42" data-mp="3mrnrunzmtsyo">Total de bonos</p>
          <p className="font-display text-2xl font-extrabold text-cream sm:text-3xl" data-id="element-43" data-mp="3rqqww8fm3z6n">{totalBonuses} bonos exclusivos</p>
        </div>

        <p className="mx-auto mt-6 max-w-xl rounded-lg border border-gold bg-gold-soft px-5 py-4 text-center text-sm font-semibold text-ink" data-id="element-44" data-mp="j7t6qgp1qzrj">
          Valor total de los {totalBonuses} bonos <span className="mx-1 text-muted line-through" data-id="element-45" data-mp="9b6lhqst66oz">{bonusTotalValue}</span>
          <b className="font-extrabold" data-id="element-46" data-mp="e9rlbp45eocw">→ GRATIS con tu Megapack</b>
        </p>
      </div>
    </section>;
}